import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { AuthenticationService } from '../_services';
// para formulario
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { MatSnackBar} from '@angular/material/snack-bar';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { DatosFacturaService } from '../_services'

/**
 * @title Table retrieving data through HTTP
 */
@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss']
})



export class SalesComponent implements AfterViewInit {
  displayedColumns: string[] = ['created', 'number', 'title', 'state', 'base_amount', 
  'iva_amount', 'total_amount', 'gateway_fee_base', 'gateway_fee_iva',
  'shipping_paid', 'shipping_paid_iva', 'fulfillment_cost', 'fulfillment_cost_iva', 'vertigo_commission_base',
  'vertigo_commission_iva', 'total_consignante'];
  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];
  coins;
  la_fecha_corte;

  currentRole: any;

  // para formulario 
  facturaForm: FormGroup;
  form_factura: []
  datos_factura: any = {};


  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(
    private formBuilder: FormBuilder, // para formulario
    private snackBar: MatSnackBar, // para confirmacion de formulario
    private _httpClient: HttpClient,
    private _hs: HttpService,
    private authenticationService: AuthenticationService,
    private datos_facturaService: DatosFacturaService,
  ) { 
    this.authenticationService.currentRole.subscribe(x => this.currentRole = x);
  }

  ngOnInit() {
    this.facturaForm = this.formBuilder.group({
      consignor_id: ['', Validators.required],
      platform_name: ['', Validators.required],
      customer_email: ['', Validators.required],
      uso_de_cfdi: ['', Validators.required],
      customer_name: ['', Validators.required],
      tax_id: ['', Validators.required],
    });
  }

  onSubmitFD() {
    console.log("submitted el form entrada cedos")
    this.datos_factura["consignor_id"] = this.facturaForm.value.consignor_id
    this.datos_factura["platform_name"] = this.facturaForm.value.platform_name
    this.datos_factura["customer_email"] = this.facturaForm.value.customer_email
    this.datos_factura["uso_de_cfdi"] = this.facturaForm.value.uso_de_cfdi
    this.datos_factura["customer_name"] = this.facturaForm.value.customer_name
    this.datos_factura["tax_id"] = this.facturaForm.value.tax_id
    

    console.log(this.datos_factura)
     this.datos_facturaService.registrar(this.datos_factura)
            .pipe(first())
            .subscribe(
                data => {
                   //  this.router.navigate([this.returnUrl]);
                   console.log("guardado recibido en component")
                   console.log("la data es")
                   console.log(data)
                   //this.openSnackBar("Compra guardada", "OK")
                   this.snackBar.open("Transaction guardada", "OK", {                      
                      duration: 2000,
                    });
                   
                },
                error => {
                  //  this.error = error;
                    // this.loading = false;
                    console.log("error recibido en component")
                });
  }




  ngAfterViewInit() {

    // this._hs.ffs_pendientes().subscribe(res => {
    //   this.coins = <any>res;
    //   this.la_fecha_corte = "el primer cambio";
    //   console.log("vamos con el resultado en ngAfterViewInit")
    //   console.log(this.coins);
    // } );

    

    this.exampleDatabase = new ExampleHttpDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          console.log("vamos en la 72")
	    		console.log(data)

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  


  }

  setClasses(fecha_creado) {
    let hoy = new Date();
    let fecha_pago = new Date(fecha_creado);

    let fecha_corte = new Date(this.coins);


   
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }




}



export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<GithubApi> {
    console.log(sort)
    console.log(order)
    console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_sales.json' + page;
    // const href = 'http://localhost:3000/query_sales.json' + page;
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<GithubApi>(requestUrl);
  }
}
